<div class="close-container">
    <img src="../assets/close_icon.svg" (click)="onClickClose()" class="close" role="button" tabindex="0" aria-label="Close" alt="Close" (keydown.enter)="onClickClose()" (keydown.space)="$event.preventDefault(); onClickClose()" />
  </div>
  <div class="container">
    <!-- <p class="title-section font-weight-500">Terms and Conditions</p> -->
    <!-- <p class="desc-section font-weight-400">
      Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
      Ipsum has been the industry's standard dummy text ever since the 1500s, when
      an unknown printer took a galley of type and scrambled it to make a type
      specimen book. It has survived not only five centuries, but also the leap
      into electronic typesetting, remaining essentially unchanged.
    </p> -->
    <div [innerHTML]="termsAndCondition | safeHtml" id="view_terms_and_conditions"></div>
    <div class="privacy-section">By accepting the myQ Connected Garage Terms of Use, I consent to HondaΓÇÖs processing of my vehicleΓÇÖs location data. For more information, view the <span class="privacy-link">Privacy Notice.</span></div>
    <div *ngIf="!hideCancelButton" class="action-btn-container">
      <button mat-flat-button class="edit-form-button standard-btn btn-width danger-btn" (click)="onCancel()">
        Cancel
      </button>
      <button  mat-flat-button *ngIf="data.showAcceptBtn" class="edit-form-button standard-btn btn-width primar-btn" (click)="onAccept()">
        Accept
      </button>
    </div>
  </div>
